import React from 'react';
import reactStringReplace from 'react-string-replace';

import locKeys from '../i18n';
import i18nChoicePattern from './i18nChoicePattern';

function i18n(key: string, ...params: Array<string | number | React.ReactNode>): string | React.ReactNode {
    const langKeys = locKeys.en as Record<string, string | undefined>;
    const rawValue = langKeys[key];
    if (!rawValue) {
        return `i18n: ${key}`;
    }

    const isParams = rawValue.match(/(\{\d+\})/g);
    let value: string | React.ReactNode[] = i18nChoicePattern(rawValue, params);

    if (isParams) {
        if (isParams.length !== params.length) {
            console.error('i18n: Param count error for ' + key);
        }
        params.forEach((param, idx) => {
            if (typeof param === 'object' && param !== null) {
                value = reactStringReplace(value, '{' + idx + '}', () => React.cloneElement(param as React.ReactElement, { key: idx }));
            } else {
                value = (value as string).replace('{' + idx + '}', String(param));
            }
        });
    }

    return value;
}

export default i18n;
